<template>
  <div class="fxRow registerWrap">
    <Header></Header>
    <div class="firmBgImg">
      <Carousel></Carousel>
    </div>
    <div class="fxRow msRegister">
      <div class="fromWrap">
        <div class="msTitle">
          <span class="black45 fwb">{{ $t("register.registerTitle") }}</span>
        </div>
        <el-form :model="registerForm" :rules="rules" ref="registerForm" label-width="0px" @submit.native.prevent class="msContent">
          <el-form-item prop="email" class="wdb100 mb26">
            <el-input
              type="text"
              v-model="registerForm.email"
              :placeholder="$t('register.emailPlaceholder')"
              @keyup.enter.native="submitForm('registerForm')"
              v-regexFilter="$halfWidthRegex"
            ></el-input>
          </el-form-item>
          <el-form-item prop="password" class="wdb100 mb26">
            <el-input
              type="password"
              :placeholder="$t('register.pwPlaceholder')"
              v-model="registerForm.password"
              @keyup.enter.native="submitForm('registerForm')"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="passwordAffirm" class="wdb100 mb26">
            <el-input
              type="password"
              :placeholder="$t('register.affirmPwPlaceholder')"
              v-model="registerForm.passwordAffirm"
              @keyup.enter.native="submitForm('registerForm')"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item prop="emailRecLanguage" class="wdb100 mb60">
            <el-select v-model="registerForm.emailRecLanguage" :placeholder="$t('register.receiptLanguage')" class="wdb100">
              <el-option :label="$t('account.account.chinese')" value="zh"></el-option>
              <el-option :label="$t('account.account.english')" value="en"></el-option>
            </el-select>
          </el-form-item>

          <div class="wdb100 login-btn">
            <el-button type="primary" @click="submitForm('registerForm')">{{ $t("register.registerTitle") }}</el-button>
          </div>
        </el-form>

        <div class="wdb100 pt6">
          <p class="tar black88 loginTips">
            {{ $t("common.alreadyHave") }}?
            <router-link to="/login">{{ $t("common.goLogin") }}</router-link>
          </p>
        </div>
      </div>
    </div>
    <div class="footBox">
      <p class="black88 fs12">
        {{ $t("login.copyright") }}
        <a href="https://beian.miit.gov.cn/" target="_blank" class="blue">{{ $t("login.records") }}</a>
      </p>
    </div>
  </div>
</template>

<script>
import { postRequest } from "@/api/common";
import { regularObj } from "@/utils/common";
import Header from "./components/Header";
import Carousel from "./components/Carousel";
import { mapGetters } from "vuex";
export default {
  name: "Register",
  data() {
    return {
      registerForm: {
        email: null,
        password: null,
        passwordAffirm: null,
        emailRecLanguage: null,
      },
      clickSwitch: true, // 防止恶意提交
      rules: {
        email: [
          {
            required: true,
            message: this.$t("register.emailHint"),
            trigger: "submit",
          },
          {
            type: "email",
            message: this.$t("common.regular.email"),
            trigger: "submit",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("register.passwordHint"),
            trigger: "submit",
          },
          {
            pattern: regularObj.password,
            message: this.$t("common.regular.password"),
            trigger: "submit",
          },
        ],
        passwordAffirm: [
          {
            required: true,
            message: this.$t("register.affirmPasswordHint"),
            trigger: "submit",
          },
          {
            pattern: regularObj.password,
            message: this.$t("common.regular.password"),
            trigger: "submit",
          },
        ],
        emailRecLanguage: [
          {
            required: true,
            message: this.$t("register.receiptLanguage"),
            trigger: "submit",
          },
        ],
      },
    };
  },
  components: {
    Header,
    Carousel,
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 注册按钮
    submitForm(registerForm) {
      this.$refs[registerForm].validate(valid => {
        if (valid) {
          if (this.registerForm.password == this.registerForm.passwordAffirm) {
            if (this.clickSwitch) {
              // 关闭提交按钮
              this.clickSwitch = false;
              postRequest("/signUp", {
                email: this.registerForm.email,
                password: this.registerForm.password,
                emailRecLanguage: this.registerForm.emailRecLanguage,
              })
                .then(res => {
                  // this.$message.info(this.$t('common.info.emailSend'))
                  this.$router.push("/remind?type=1");
                })
                .catch(err => {
                  this.clickSwitch = true;
                });
            }
          } else {
            this.$message.warning(this.$t("register.inconformity"));
          }
        } else {
          return false;
        }
      });
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.registerWrap {
  width: 100%;
  min-width: 1200px;
  height: 100%;
  min-height: 800px;
  background: #f1f5fc;
  position: relative;
}

.firmBgImg {
  width: 60%;
  height: 100%;
  background: #f1f5fc;
}

.msRegister {
  width: 40%;
  height: 100%;
  background: #fafcff;
  box-shadow: 0px 21px 40px 0px rgba(208, 229, 255, 0.26);

  ::v-deep {
    .el-input__inner {
      background: #ffffff;
      border-color: #e1ecff;
      border-radius: 6px;
      height: 50px;
      line-height: 50px;
    }
  }
}

.fromWrap {
  width: 430px;
  margin: 0px auto;
}

.msTitle {
  width: 100%;
  text-align: center;
  padding-bottom: 60px;
  font-size: 22px;
}

.loginline {
  color: #e6e6e6;
}

.msContent {
  width: 100%;
}

.login-btn {
  text-align: center;
}

.login-btn button {
  width: 100%;
  height: 50px;
  font-size: 16px;
  font-weight: 600;
}

.loginTips,
.forgetTips {
  font-size: 14px;
  line-height: 36px;
}

.loginTips a {
  color: #0072ff;
}

.forgetTips a {
  color: #667288;
}

.protocol:hover {
  color: #0072ff;
}

.footBox {
  position: absolute;
  bottom: 14px;
  left: 0;
  width: 60%;
  text-align: center;
  z-index: 10000;
}
</style>
